import { useState } from 'react'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'

import useCsrfToken from '@/hooks/useCsrfToken'

import { Row } from '@/Components/Layout/Row'
import { usePage } from '@/Components/Pages/PageProvider'

const UserMenu = () => {
  const { currentUser } = usePage()
  const {
    name,
    permissions: {
      users: { manage: canManageUsers }
    }
  } = currentUser || {}
  const csrfToken = useCsrfToken()

  const [accountMenuAnchorEl, setAccountMenuAnchorEl] =
    useState<null | HTMLElement>(null)

  const accountMenuId = 'account-menu'
  const isMenuOpen = Boolean(accountMenuAnchorEl)
  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAccountMenuAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAccountMenuAnchorEl(null)
  }

  const handleSignout = () => {
    fetch('/users/sign_out', {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'X-CSRF-Token': csrfToken
      }
    }).then(() => {
      window.location.href = '/'
    })
  }

  return (
    <>
      {name && (
        <MenuItem
          id="account-menu-button"
          component="a"
          onClick={handleProfileMenuOpen}
          sx={{
            padding: 0,
            '&:hover': {
              backgroundColor: 'transparent'
            }
          }}
        >
          <Row alignItems="center" fontSize={16}>
            <Typography
              variant="body1"
              color="primary"
              pr={1}
              fontSize={20}
              fontWeight={600}
            >
              {name}
            </Typography>
            {isMenuOpen ? (
              <KeyboardArrowUpIcon color="primary" sx={{ fontSize: 22 }} />
            ) : (
              <KeyboardArrowDownIcon color="primary" sx={{ fontSize: 22 }} />
            )}
          </Row>
        </MenuItem>
      )}
      {!name && (
        <IconButton onClick={handleProfileMenuOpen}>
          <AccountCircleIcon color="primary" />
        </IconButton>
      )}
      <Menu
        anchorEl={accountMenuAnchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        id={accountMenuId}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem component="a" href="/account/edit">
          My account
        </MenuItem>
        {canManageUsers && (
          <MenuItem component="a" href="/admin/users">
            Manage users
          </MenuItem>
        )}
        <MenuItem disabled divider />
        <MenuItem onClick={handleSignout} component="a" id="sign-out">
          Sign out
        </MenuItem>
      </Menu>
    </>
  )
}

export default UserMenu
